common.View.create('admin.orders.CreateEdit', {

    loadingProps: [
        // First card
        'driver_user_id', 'license_plate_id', 'date', 'execute_start_at', 'execute_end_at',

        // Second card
        'left_at', 'returned_at', 'crane', 'low_loader', 'gantry', 'extendable_trailer', 'pause', 'toll', 'toll_details',

    ],

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.element
            .find('.select2')
                .select2();

        // @ugly
        // Abort due to not a normal order?
        if(document.title.toLowerCase().includes('interne order'))
            this.initInternalOrder();

        else {
            //
            this.storeRequireds();
            this.init_loading_and_unloading_are_equal();
        }

        //
        this.initDestroy();
    },

    storeRequireds()
    {
        for(let type of ['loading', 'unloading'])
        {
            for(let prop of this.loadingProps) {
                let element = this.element.find('*[name="' + type + '_' + prop + '"]');

                element.attr('data-original-required', element.attr('required'));
            }
        }
    },

    init_loading_and_unloading_are_equal()
    {
        this.element
            .find('input[name="loading_and_unloading_are_equal"]')
            .change(this.manage_loading_and_unloading_are_equal.bind(this));

        for(let name of this.loadingProps)
        {
            this.element
                .find('*[name="loading_' + name + '"]')
                .change(this.manage_loading_and_unloading_are_equal.bind(this));
        }

        this.manage_loading_and_unloading_are_equal();
    },

    manage_loading_and_unloading_are_equal()
    {
        let isActive = this.element
            .find('input[name="loading_and_unloading_are_equal"]')
            .val() == '1';

        this.element.find('div[data-card-title="Lossen"]')[isActive ? 'hide' : 'show']();

        if(isActive)
        {
            for(let name of this.loadingProps)
            {
                let loadingElement = this.element.find('*[name="loading_' + name + '"]');
                let unloadingElement = this.element.find('*[name="unloading_' + name + '"]');

                unloadingElement.attr('required', false);
                unloadingElement.val(loadingElement.val());
                unloadingElement.trigger('change');
            }
        }
        else {
            for(let name of this.loadingProps)
            {
                let unloadingElement = this.element.find('*[name="unloading_' + name + '"]');

                unloadingElement.attr('required', unloadingElement.attr('data-original-required'));
            }
        }

        this.element.find('div[data-card-title="Laden"] .text-base').text(isActive ? 'Laden en lossen' : 'Laden');
    },

    initInternalOrder()
    {
        this.element.find('div[data-card-title="Laden"] .text-base').text('Laden en lossen');
    },

    initDestroy()
    {
        this.element.find('button[name="action"][value="destroy"]')
            .click(() => {

                // Abort due to not confirmed?
                Swal.fire({
                    title: 'Zeker weten?',
                    text: 'Weet je zeker dat je deze wilt verwijderen?',
                    showDenyButton: true,
                    confirmButtonText: 'Ja, verwijder',
                    denyButtonText: `Nee, annuleer`,
                    confirmButtonColor: 'rgb(248, 113, 113)',
                    denyButtonColor: '#999999'
                }).then((result) => {

                    if (!result.isConfirmed)
                        return;

                    // Create a form and submit.
                    $('<form method="post" />')
                        .attr('action', this.element.find('form').attr('action'))
                        .append($('<input type="hidden" name="_method" value="delete" />'))
                        .appendTo(document.body)
                        .submit();

                });


            });
    }

});
